import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class CustomIconService {
    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {}

    init() {
        this.matIconRegistry.addSvgIcon(
            `dashboard`,
            this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg-icons/dashboard.svg')
        );

        this.matIconRegistry.addSvgIcon(
            `settings`,
            this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg-icons/settings.svg')
        );

        this.matIconRegistry.addSvgIcon(
            `disclaimer`,
            this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg-icons/disclaimer.svg')
        );

        this.matIconRegistry.addSvgIcon(
            `close`,
            this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg-icons/close.svg')
        );

        this.matIconRegistry.addSvgIcon(
            `check`,
            this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg-icons/check.svg')
        );

        this.matIconRegistry.addSvgIcon(
            `info-icon`,
            this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg-icons/info.svg')
        );

        this.matIconRegistry.addSvgIcon(
            `exit-to-app`,
            this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg-icons/exit.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'create',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/create.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'producer-info',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/producer_info.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'get_app',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/download.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'drag_handle',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/drag_handle.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'view_module',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/view_module.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'filter',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/filter.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'calculate',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/calculate.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'calculator',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/calculator.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'lock',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/lock.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mdd_expand_circle_right',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/svg-icons/expand_circle_right.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'mdd_feed',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/feed.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mdd_herd',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/herd.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'mdd_milk',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/milk.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mdd_single_herd',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/single_herd.svg')
        );
        this.matIconRegistry.addSvgIcon(
            'mdd_atr',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/atr.svg')
        );

        this.matIconRegistry.addSvgIcon(
            'everag',
            this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg-icons/everag-icon.svg')
        );
    }
}
